/**
 * faceIdPref.js — s114 (Dr. Rami 2026-10-22, Face ID opt-in canvas approved: F1 Settings, F2 sign-up, F3 lock screen).
 * Face ID unlock is something the patient TURNS ON. The choice is kept on this device, per user
 * (`orella_faceid_unlock:<userId>`), so a second account signed in on the same phone never inherits it.
 * It means nothing without the session PIN: turning the PIN off clears it. Never throws.
 */
export const FACE_ID_PREF_PREFIX = 'orella_faceid_unlock:'

function keyFor(userId) {
  const id = userId == null ? '' : String(userId).trim()
  return id ? FACE_ID_PREF_PREFIX + id : ''
}

export function getFaceIdPref(userId) {
  const k = keyFor(userId)
  if (!k) return false
  try { return globalThis.localStorage?.getItem(k) === '1' } catch { return false }
}

export function saveFaceIdPref(userId, on) {
  const k = keyFor(userId)
  if (!k) return
  try {
    if (on) globalThis.localStorage?.setItem(k, '1')
    else globalThis.localStorage?.removeItem(k)
  } catch { /* storage blocked: the choice simply isn't kept */ }
}

export function clearFaceIdPref(userId) {
  saveFaceIdPref(userId, false)
}
